import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { CurrentService } from '../../../services/current.service';
import { DatasService } from '../../../services/datas.service';
import { GTM } from 'src/app/services/gtm.service';
import { CONTEXT } from 'src/app/enum/context';

@Component({
  selector: 'ng-hbm-bdi-style',
  templateUrl: './style.component.html'
})
export class StyleComponent implements OnInit {

  styles: any;

  @Output() onComplete: EventEmitter<void> = new EventEmitter();

  constructor(public current: CurrentService, public datas: DatasService, private gtm: GTM) { }
  
  async ngOnInit(): Promise<void> {
    this.gtm.trackPage(CONTEXT.KITCHEN, 'need-mapping', 'style', this.datas.getKitchenGtmData(this.current));
    this.styles = await this.datas.getStyles();
  }

  selectStyle(styleId: number) {
    this.gtm.trackEvent("click", "need-mapping", "style-" + styleId);
    if (this.current.styleId !== styleId) {
      this.current.reset();
      this.current.styleId = styleId;
    }
    this.onComplete.emit();
  }
}
